<kendo-dialog-titlebar (close)="cancel()">
  <div class="ss-dialog-title">
    {{ "module.product.popup.title" | translate }}
  </div>
</kendo-dialog-titlebar>
  <!-- CONTENT -->
  
<div class="ss-popup-container">
  <kendo-grid
    [data]="gridView"
    [pageSize]="state.take"
    [skip]="state.skip"
    [sort]="state.sort"
    [filter]="state.filter"
    [sortable]="true"
    [pageable]="pageable"
    [filterable]="true"
    [resizable]="true"
    [selectable]="gridService.selectableSettings"
    scrollable="scrollable"
    [loading]="isLoading"
    class="ss-list-grid"
    (cellClick)="select($event)"
    (dataStateChange)="dataStateChange($event)"
    [loading]="isLoading"
  >
    <!-- COLUMNS -->

    <!-- ID -->
    <kendo-grid-column
      field="productId"
      title="{{ 'module.product.model.productId' | translate }}"
      [width]="25"
      [minResizableWidth]="80"
      [maxResizableWidth]="160"
      filter="numeric"
      format="0n0"
    ></kendo-grid-column>


    <!-- productNumber -->
    <kendo-grid-column
      field="productNumber"
      title="{{ 'module.product.model.productNumber' | translate }}"
      [width]="40"
      [minResizableWidth]="120"
      [maxResizableWidth]="160"
      filter="text"
    ></kendo-grid-column>


    <!-- productTitle -->
    <kendo-grid-column
      [field]="productTitle"
      title="{{ 'module.product.model.productTitle' | translate }}"
      [width]="120"
      [minResizableWidth]="150"
      [maxResizableWidth]="500"
      filter="text"
    ></kendo-grid-column>

    

  </kendo-grid>
</div>
  